import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './locales/en.json'
import fr from './locales/fr.json'

Vue.use(VueI18n)

const messages = {
    en,
    fr
}

const savedLocale = localStorage.getItem('user-locale') || 'fr';

const i18n = new VueI18n({
    locale: savedLocale,
    fallbackLocale: 'en',
    messages
})

export default i18n
